import axios from 'axios';
import { logout } from '../redux/authSlice';
import { startLoading, stopLoading } from '../redux/loadingSlice';
import { setError } from '../redux/errorSlice';
import store from '../redux/store';

const api = axios.create({
  baseURL: 'https://api.sinterec.cl', // Base URL de la API
});

// Interceptor para Despachar logout si el backend indica sesión expirada 403 ERROR HANDLING
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      // Despachar logout si el backend indica sesión expirada
      store.dispatch(logout());
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);


// Interceptor para añadir el token en cada solicitud
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // No sobrescribir Content-Type si es FormData
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    
    return config;
  },
  (error) => {
    console.error('Error en el interceptor de Axios:', error);
    return Promise.reject(error);
  }
);

// Interceptor para activar el spinner en cada solicitud (excepto carga masiva)
api.interceptors.request.use(
  (config) => {
    // Excluir la ruta de carga masiva del spinner global
    if (!config.url.includes('/api/carga-masiva')) {
      store.dispatch(startLoading());
    }
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);


// Interceptor para manejar respuestas y errores
api.interceptors.response.use(
  (response) => {
    // Excluir la ruta de carga masiva del spinner global
    if (!response.config.url.includes('/api/carga-masiva')) {
      store.dispatch(stopLoading());
    }
    return response;
  },
  (error) => {
    store.dispatch(stopLoading()); // Siempre detener el loading en caso de error

    // Manejo de errores HTTP
    if (error.response) {
      const { status, data } = error.response;
      store.dispatch(
        setError({
          message: data.message || 'Ocurrió un error inesperado.',
          status: status,
          redirectTo: status === 403 ? '/cambio-clave' : null,
        })
      );
    } else if (error.request) {
      store.dispatch(
        setError({
          message: 'No se recibió respuesta del servidor.',
          status: 500,
        })
      );
    } else {
      store.dispatch(
        setError({
          message: 'Error al configurar la solicitud.',
          status: 500,
        })
      );
    }
    return Promise.reject(error);
  }
);

export default api;